import getUserIdentity from "../identity/getUserIdentity";
import { configureRequest } from "@asosteam/asos-web-request";
import { getAuthorisationHeader } from "../identity";
import getRequestUrl from "./getRequestUrl";
import { name, version } from "../../../appDetails";
import {
  NOTIFICATIONS_SERVICE_ID,
  NOTIFICATIONS_PREFERENCE_ID,
  CONSENTED_STATUS,
  EMAIL_CHANNEL,
  PREFERENCE_STATUS
} from "./constants";
import webContextProvider from "../../providers/webContextProvider";

export default async () => {
  const { customerId } = await getUserIdentity();
  const authorisation = await getAuthorisationHeader();
  const headers = {
    Authorization: authorisation,
    "Content-Type": "application/json"
  };
  const request = configureRequest({ client: { name, version } });
  const { browseLanguage, browseCountry } = webContextProvider();

  const url = `${getRequestUrl(
    customerId
  )}?serviceId=${NOTIFICATIONS_SERVICE_ID}&country=${browseCountry}&expand=content&lang=${browseLanguage}&interactionmode=customer`;

  const response = await request.get({ url, headers });

  const stockService = response.data.services.find(
    ({ serviceId }) => serviceId === NOTIFICATIONS_SERVICE_ID
  );

  if (!stockService) return PREFERENCE_STATUS.UNKNOWN;

  const notificationsPreference = stockService.preferences.find(
    ({ preferenceId }) => preferenceId === NOTIFICATIONS_PREFERENCE_ID
  );

  if (!notificationsPreference) return PREFERENCE_STATUS.UNKNOWN;

  const isConsentedIn =
    notificationsPreference.consentStatus === CONSENTED_STATUS;
  const hasEmailChannel =
    notificationsPreference.customerChannels?.includes(EMAIL_CHANNEL);

  return isConsentedIn && hasEmailChannel
    ? PREFERENCE_STATUS.OPTED_IN
    : PREFERENCE_STATUS.NOT_OPTED_IN;
};
